<template>
  <div>
    <el-form class="toolbar" :inline="true" :model="query" @keyup.enter.native="pageIndex = 1; load()">
      <el-form-item label="主物料">
        <el-select v-model="query.materialId" placeholder="请选择主物料" size="small" filterable clearable style="width: 280px;">
          <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户名称">
        <el-input v-model="query.customerName" size="small" clearable />
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('base:materialCustomer:list')" type="primary" size="small" @click="pageIndex = 1; load()">查询</el-button>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button v-if="isAuth('base:materialCustomer:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" style="width:100%" class="master-data-table"
      :header-cell-style="headStyle" @row-dblclick="rowDblclick">
      <el-table-column type="index" label="序号" header-align="center" align="center" width="60" />
      <el-table-column prop="materialCode" label="主物料编码" header-align="center" align="left" width="130" />
      <el-table-column prop="materialName" label="主物料名称" header-align="center" align="left" width="150" show-overflow-tooltip />
      <el-table-column prop="customerName" label="客户名称" header-align="center" align="left" width="180" show-overflow-tooltip />
      <el-table-column prop="cusMaterialCode" label="客户物料编码" header-align="center" align="left" width="160" />
      <el-table-column prop="specs" label="规格型号" header-align="center" align="left" show-overflow-tooltip />
    </el-table>
    <el-pagination class="list-pagination" @size-change="val => { pageSize = val; pageIndex = 1; load() }"
      @current-change="val => { pageIndex = val; load() }" :current-page="pageIndex" :page-sizes="[20, 50, 100]"
      :page-size="pageSize" :total="total" layout="total, sizes, prev, pager, next, jumper" />
    <material-customer-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialCustomerAddOrUpdate from './materialCustomer-add-or-update'

export default {
  name: 'MaterialCustomer',
  components: { MaterialCustomerAddOrUpdate },
  data() {
    return {
      query: { materialId: '', customerName: '' }, materials: [], list: [], pageIndex: 1, pageSize: 20, total: 0, loading: false,
      addOrUpdateVisible: false, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    this.loadMaterials()
    this.load()
  },
  activated() {
    this.loadMaterials()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadMaterials() {
      request.post('/base/material/page', { currentPage: 1, pageSize: 500 }).then(res => {
        this.materials = (res.data && res.data.list) || []
      }).catch(() => {})
    },
    load() {
      this.loading = true
      request.post('/base/materialCustomer/list', {
        currentPage: this.pageIndex, pageSize: this.pageSize,
        partnerId: this.query.materialId, partnerName: this.query.customerName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    rowDblclick(row) {
      if (!this.isAuth('base:materialCustomer:info')) return
      this.open(row, true)
    },
    open(row, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => { this.$refs.addOrUpdate.init(row, readonly, this.query.materialId) })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 10px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.master-data-table >>> tbody tr { cursor: pointer; }
</style>
